import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";
import { getTotals } from "../store";

export const createTransactionForRefund = createAsyncThunk(
  "store/refund-amount",
  async (transaction, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        `/admin/transactions/refund`,
        transaction.transactionPayload
      );
      dispatch(getAllTransactions({ page: 0, size: 50 }));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getTransactions = createAsyncThunk(
  "store/get-transactions",
  async (transaction, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/transactions?page=${transaction.page || 0}&size=${50}&text=${transaction?.text}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllTransactions = createAsyncThunk(
  "store/get-all-transactions",
  async (transaction, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/transactions?storeId=${transaction?.storeId || ""}&page=${
          transaction.page || 0
        }&size=${50}&text=${transaction.text || ""}&start_date=${
          transaction.start_date || ""
        }&end_date=${transaction.end_date || ""}&status=${transaction?.status || ""}`
      );
      
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const verifyTransaction = createAsyncThunk(
  "store/verify-transaction",
  async (transaction, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/transactions/verify/${transaction.transactionId}`,
        transaction.updatePayload
      );
      dispatch(getAllTransactions({ page: 0, size: 50, status:transaction?.status || "" }));
      dispatch(getTotals())
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const deleteTransaction = createAsyncThunk(
  "store/delete-transaction",
  async (transactionId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/transactions/delete/${transactionId}`
      );
      dispatch(getAllTransactions({ page: 0, size: 50 }));
      dispatch(getTotals())
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getDateFilterOrderTransactions = createAsyncThunk(
  "store/get-order-transactions",
  async (dates, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/transactions/orders?start_date=${dates.start_date}&end_date=${dates.end_date}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
